import { useQuery } from '@tanstack/react-query';
import useApi from '../../../../../../../utils/AxiosWrapper';
import { useIsPreActiveCustomer } from '../../../../../../../hooks/useIsPreActiveCustomer';
import { getDemoTopVendors } from '../demoAccountingData';

export function useTopVendors(
  customerId: string,
  year: number,
  category?: string,
  limit = 10
) {
  const { callProtectedApi } = useApi();
  const isPreActive = useIsPreActiveCustomer();

  return useQuery({
    queryKey: ['accounting-top-vendors', customerId, year, category, limit],
    queryFn: async () => {
      const params = new URLSearchParams({
        startDate: `${year}-01-01`,
        endDate: `${year + 1}-01-01`,
        limit: String(limit),
      });
      if (category) params.set('category', category);

      const response = await callProtectedApi(
        `/accounting/${customerId}/top-vendors?${params.toString()}`,
        'get'
      );
      return response?.data?.data;
    },
    // See useIncomeStatement — demo data for pre-active, no request fired. The
    // demo vendors carry a category, so the category filter still works.
    enabled: !!customerId && !isPreActive,
    placeholderData: isPreActive
      ? () => getDemoTopVendors(year, category, limit)
      : undefined,
  });
}
